import { useCallback } from "react"
import { useGetData, usePostData } from "services/sales"
import { handleResponse } from "utils/fetch"

export const ALLOW_MULTIPLE_QUANTITY_PRODUCTS = ["741563c1-26bd-4ddf-83a2-eda1f3f14c24"]

export const getAccessoryProperties = (product) => {
  // [site, model, mod]
  return product?.CodeName ? product.CodeName.split(",") : []
}

export const isAddonProduct = (product) => !!product.Addon?.length

export const getAccessorySite = (product) => getAccessoryProperties(product)[0]

export const useProducts = () => {
  const queryData = usePostData("/tw/api/search/result")
  // TODO `tw/api/product/get-product-color` is not in used any more, should ask backend to remove it
  const queryColors = usePostData(useCallback((id) => `/tw/api/product/get-product-color?id=${id}`, []))

  const queryProductColors = useCallback(
    (productId) =>
      queryColors(productId)
        .then(handleResponse)
        .then((response) => response.Data),
    [queryColors],
  )

  const queryProducts = useCallback(
    (payload) =>
      queryData(payload)
        .then(handleResponse)
        .then((response) => response.Data),
    [queryData],
  )

  return { queryProductColors, queryProducts }
}

export const useProduct = (id) => {
  const fetchData = useGetData(`/tw/api/scooter/product-info/${id}`)
  const fetchDetails = usePostData(
    useCallback(({ storeId, time }) => `/tw/api/product/detail?id=${id}&storeId=${storeId}&time=${time}`, [id]),
  )

  const fetchProduct = useCallback(() => {
    return fetchData().then((response) => {
      if (response.result !== 1) {
        return Promise.reject({
          code: response.error_code,
          message: response.message,
        })
      } else {
        return response.data[0]
      }
    })
  }, [fetchData])

  const fetchProductDetails = useCallback(
    ({ storeId, time }) =>
      fetchDetails({ storeId, time })
        .then(handleResponse)
        .then((response) => response.Data),
    [fetchDetails],
  )

  return { fetchProduct, fetchProductDetails }
}
